import React, {Component} from 'react';

import styles from '../../static/css/pageStyleModules/infoView.module.scss';
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent';

export default class InfoView extends Component {

    constructor(props){
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className={styles['infoViewArea']}>
              <div className={styles['absoluteArea']}>
                <div className={styles['infoViewMainArea']}>
                  <div className={styles['introductionArea']}>
                    <h2>ありがとログとは</h2>
                    <p>
                      <span>『ありがとログ』は、ありがとうの気持ちを忘れないように記録しておけるアプリです。</span>
                      <br/>
                      <span>誰からいつどんなことをしてもらったか、どんなふうに感じたかを書き留めておくことで、ありがとうの気持ちを記録として残しておくことができます。</span>
                      <br/>
                      <span>ありがとチェック機能つきで、「ちゃんと感謝の気持ちを伝えたか」「お返しができたか」のチェックなどに活用できます。</span>
                      <br/>
                      <span>メンバーは自由に登録可能。頭と表情と色の組み合わせで好きなアイコンが作れます。</span>
                    </p>
                    <div className={styles['shareRack']}>
                      <a href="https://twitter.com/share?text=ありがとう記録アプリ『ありがとログ』&url=https://thanksLog.firebaseapp.com/" target="_brank" rel="nofollow"
                      className={styles['shareButton']} 
                      style={{backgroundColor:'#55acee'}}>
                        <SvgIconBaseComponent image={'twitter'} fillColor={'#ffffff'} />
                      </a>
                      <a href="http://line.me/R/msg/text/?ありがとう記録アプリ『ありがとログ』%0D%0Ahttps://thanksLog.firebaseapp.com/" target="_brank"
                      className={styles['shareButton']} style={{backgroundColor:'#00b900'}}>
                        <SvgIconBaseComponent image={'line'} fillColor={'#ffffff'} />
                      </a>
                      <a href="http://www.facebook.com/share.php?u=https://thanksLog.firebaseapp.com/" target="_brank"
                      className={styles['shareButton'] + ' ' + styles['facebookIcon']} style={{backgroundColor:'#3B5998'}}>
                        <SvgIconBaseComponent image={'facebook'} fillColor={'#ffffff'} />
                      </a>
                    </div>
                  </div>
                  <div className={styles['contactArea']}>
                    <h2>お問い合わせ</h2>
                    <p><b>ご感想・ご意見・ご要望・バグ報告</b>などは<br></br>こちらのtwitterまでお願いします！</p>
                    <div style={{textAlign:'center'}}>
                      <a className={'touchActiveDark'}
                      target="_blank" rel="noopener noreferrer"
                      href="https://twitter.com/koji_takahashhi">
                        <div className={styles['twitterIcon']}>
                          <SvgIconBaseComponent image={'twitter'} fillColor={'#55acee'} />
                        </div>
                        <span>@koji_takahashhi</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        )
    }

};